<template>
  <dx-scroll-view height="100%" width="100%" class="with-footer single-card" style="position: relative">

    <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">

      <div class="logo" style="margin: 0 auto; width: 451px; text-align: center; margin-bottom: 10px;">
        <img :src="$branding.logo" alt="" style="width: 80%">
      </div>
      <div class="dx-card content">
        <div class="header">
          <div class="title">{{title}}</div>
          <div class="description">{{description}}</div>
        </div>
        <slot />
      </div>

    </div>


  </dx-scroll-view>
</template>

<script>
import DxScrollView from "devextreme-vue/scroll-view";

export default {
  components: {
    DxScrollView
  },
  props: {
    title: String,
    description: String
  }
};
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
.single-card {
  width: 100%;
  height: 100%;
  background: rgb(190, 212, 223);

  .dx-card {
    width: 603px !important;
    height: 404px !important;
    border-radius: 24px !important;

    //width: 330px;
    margin: auto auto;
    padding: 76px 104px;
    flex-grow: 0;

    .screen-x-small & {
      width: 100%;
      height: 100%;
      border-radius: 0;
      box-shadow: none;
      margin: 0;
      border: 0;
      flex-grow: 1;
    }

    .header {
      margin-bottom: 30px;

      .title {
        //color: $base-text-color;
        //line-height: 28px;
        //font-weight: 500;
        //font-size: 24px;

        font-size: 28px;
        font-weight: 400;
        line-height: 38px;
        text-align: center;
      }

      .description {
        //color: rgba($base-text-color, alpha($base-text-color) * 0.7);
        line-height: 18px;
      }
    }
  }
}
</style>
